export const DEFAULT_PERSISTABLE_ENV = "prod";

export function getAgentPeerId({ objectUuid }) {
  const normalizedObjectUuid = typeof objectUuid === "string" ? objectUuid.trim() : "";

  if (!normalizedObjectUuid) {
    throw new Error("objectUuid is required");
  }

  return `agent:${normalizedObjectUuid}`;
}

export function buildAgentPeerActivationPayload({ roomId, dialogUrl, objectUuid, displayName }) {
  const agentPeerId = getAgentPeerId({ objectUuid });

  return {
    roomId,
    signalingUrl: dialogUrl,
    agentPeerId,
    agentUuid: objectUuid,
    displayName
  };
}

export function getAgentPeerActivationKey({ roomId, signalingUrl, agentPeerId }) {
  return [
    typeof roomId === "string" ? roomId.trim() : "",
    typeof signalingUrl === "string" ? signalingUrl.trim() : "",
    typeof agentPeerId === "string" ? agentPeerId.trim() : ""
  ].join("|");
}

export function buildAgentPrivateChatPayload({
  text,
  agentPeerId,
  clientMessageId,
  responseClientMessageId,
  language = undefined,
  persistableId,
  persistableEnv,
  senderUserId
}) {
  const payload = {
    text,
    recipientSessionId: agentPeerId,
    clientMessageId,
    language,
    senderUserId
  };

  const metadata = {};
  if (persistableId) {
    metadata.persistableId = persistableId;
  }
  if (persistableEnv) {
    metadata.persistableEnv = persistableEnv;
  }
  if (responseClientMessageId) {
    metadata.responseClientMessageId = responseClientMessageId;
  }

  if (Object.keys(metadata).length > 0) {
    payload.metadata = metadata;
  }

  return payload;
}

export function getAgentByPeerId(agents, agentPeerId) {
  return agents.find(agent => agent.agentPeerId === agentPeerId) || null;
}
